import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-parameter-data',
  templateUrl: './parameter-data.component.html',
  styleUrls: ['./parameter-data.component.scss']
})
export class ParameterDataComponent implements OnInit {
  ParameterForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  showSubmitButton = true;
  ExamBranch = false;
  id: any;
  parameterList: any;
  parameter: any;
  list;
  filteredExamAList: any;
  ExamAList: any[];
  SessionNo: any;
  BranchList: any;
  filteredListBranch: any;
  showVisibleAuto = false;
  ShowVisibleCale = false;
  userPermission: any;
  utp: string;
  parameterCreate = true;
  submitpayload2: any;
  constructor(public umsService: UmsService, private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router,
    private route: ActivatedRoute, private spinner: NgxSpinnerService) { }
  dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    this.submitButton = true;
    this.getParameterData();
    this.list = true;
    this.ParameterForm = this.fb.group({
      Exam: new FormControl(''),
      Type: new FormControl(''),
      ShSn: new FormControl(''),
      TextType: new FormControl(''),
      Text: new FormControl('', Validators.pattern('^[a-zA-Z]*$')),
      BrId: new FormControl(''),
      ResD: new FormControl(''),
      Text1: new FormControl(''),
    });
    // // if (this.data.key == "Edit") {
    // //   this.prepopulation(this.data.selected);
    // // }
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.fetchSupExamRecord(this.SessionNo);
    }

    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Faculty' && element.PCreate == false) {
          this.parameterCreate = false;
        }
      });
    }
  }

  prepopulation(id) {
    this.submitButton = false;
    let Exam;
    if (id.PrmType == "SH") {
      this.showVisibleAuto = false;
      this.ShowVisibleCale = true;
      Exam = id.PrmShSn
    } else {
      this.showVisibleAuto = true;
      this.ShowVisibleCale = false;
      Exam = 'C'

    }
    // this.spinner.show();
    this.ParameterForm = this.fb.group({
      Exam: new FormControl(Exam),
      Type: new FormControl(''),
      ShSn: new FormControl(''),
      TextType: new FormControl(id.PrmTextType),
      Text: new FormControl(id.PrmText),
      BrId: new FormControl(id.PrmBrId),
      ResD: new FormControl(id.PrmResD)
    });
    // const payload = {};
    // payload['Type'] = id.PrmType;
    // payload['ShSn'] = this.SessionNo;
    // payload['BrId'] = '';
    // this.umsService.getParameter(payload).subscribe((res) => {
    //   this.spinner.hide();
    //   const data = res.data[0];
    //   if (res.status){

    //    }else{

    //    }
    //  });
  }
  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.fetchSupExamRecord(this.SessionNo);
    }
    );
  }
  getParameterData() {
    const payload = {};
    payload['Type'] = '';
    payload['ShSn'] = this.SessionNo;
    payload['BrId'] = '';
    this.umsService.getParameter(payload).subscribe(res => {
      this.parameterList = res.data;
    });
  }

  submit() {
    if (this.ParameterForm.invalid) {
      this.ParameterForm.get('Exam').markAsTouched();
      // this.ParameterForm.get('ShSn').markAsTouched();
      // this.ParameterForm.get('TextType').markAsTouched();
      // this.ParameterForm.get('Text').markAsTouched();
      // this.ParameterForm.get('BrId').markAsTouched();
      // this.ParameterForm.get('ResD').markAsTouched();
      return;
    } else {
      this.saveParameter();
    }
  }

  saveParameter() {
    let ShSnValue;
    let ShSnType;
    this.submitpayload = this.ParameterForm.value;
    if (this.ParameterForm.value.Exam == 'C') {
      ShSnValue = this.SessionNo;
      ShSnType = 'SN'
      this.submitpayload['Type'] = ShSnType;
      this.submitpayload['ShSn'] = ShSnValue;
      this.submitpayload['Text'] = this.ParameterForm.value.TextType;
      this.submitpayload['TextType'] = "Name";
      this.submitpayload['BrId'] = this.ParameterForm.value.BrId ? this.ParameterForm.value.BrId : 0;
      this.submitpayload['ResD'] = this.ParameterForm.value.ResD;
      this.umsService.addParameter(this.submitpayload).subscribe(res => {
        if (res.status) {
               this.saveDataSecond()
        } else {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit()
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  
      });
  
      
    }
    else {
      ShSnValue = this.ParameterForm.value.Exam;
      ShSnType = 'SH';

      this.submitpayload['Type'] = ShSnType;
      this.submitpayload['ShSn'] = ShSnValue;
      this.submitpayload['TextType'] = 'ExamM';
      this.submitpayload['Text'] = this.ParameterForm.value.Text;
      this.submitpayload['BrId'] = this.ParameterForm.value.BrId ? this.ParameterForm.value.BrId : 0;
      this.submitpayload['ResD'] = this.ParameterForm.value.ResD;
      this.umsService.addParameter(this.submitpayload).subscribe(res => {
        if (res.status) {
          this.saveDataSecondForExam()
        } else {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit()
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  
      });
    }
   
  }



  saveDataSecond(){
    let ShSnValue;
    let ShSnType;
    if (this.ParameterForm.value.Exam == 'C') {
      ShSnValue = this.SessionNo;
      ShSnType = 'SN'
    }
    else {
      ShSnValue = this.ParameterForm.value.Exam;
      ShSnType = 'SH';
    }
    this.submitpayload2 = this.ParameterForm.value;
      this.submitpayload2['Type'] = ShSnType;
      this.submitpayload2['ShSn'] = ShSnValue;
      this.submitpayload2['TextType'] = "Autho";
      this.submitpayload2['Text'] = this.ParameterForm.value.Text1;
      this.submitpayload2['BrId'] = this.ParameterForm.value.BrId ? this.ParameterForm.value.BrId : 0;
      this.submitpayload2['ResD'] = this.ParameterForm.value.ResD;
      this.umsService.addParameter(this.submitpayload2).subscribe(res => {
        if (res.status) {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit()
        } else {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit()
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  
      });
  }

   saveDataSecondForExam(){
    let ShSnValue;
    let ShSnType;
    if (this.ParameterForm.value.Exam == 'C') {
      ShSnValue = this.SessionNo;
      ShSnType = 'SN'
    }
    else {
      ShSnValue = this.ParameterForm.value.Exam;
      ShSnType = 'SH';
    }
    this.submitpayload2 = this.ParameterForm.value;
      this.submitpayload2['Type'] = ShSnType;
      this.submitpayload2['ShSn'] = ShSnValue;
      this.submitpayload2['TextType'] = "ResD";
      this.submitpayload2['Text'] = this.ParameterForm.value.ResD;
      this.submitpayload2['BrId'] = this.ParameterForm.value.BrId ? this.ParameterForm.value.BrId : 0;
      this.submitpayload2['ResD'] = this.ParameterForm.value.ResD;
      this.umsService.addParameter(this.submitpayload2).subscribe(res => {
        if (res.status) {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit()
        } else {
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit()
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  
      });
  }
  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      // this.getParameterData();
      // this.parameter = k;
      // this.prepopulation(this.parameter);
    } else {
      this.list = true;
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }



  fetchSupExamRecord(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShSnNo'] = SnNo;
    this.umsService.getSupExamRecord(payload).subscribe((res) => {

      if (res.status) {
        this.spinner.hide();
        this.ExamAList = res.data;
        this.addStaticOption();
        this.filteredExamAList = this.ExamAList.slice();
      } else {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    );
  }


  getExamData(item) {
    let ShSnValue;
    let ShSnType;
    if (item.ShId == 'C') {
      ShSnValue = this.SessionNo;
    } else {
      ShSnValue = item.ShId;
    }
    if (this.ParameterForm.value.Exam == 'C') {
      ShSnValue = this.SessionNo;
      ShSnType = 'SN'
    }
    else {
      ShSnValue = this.ParameterForm.value.Exam;
      ShSnType = 'SH'
    }
    const payload1 = {};
    payload1['ShSn'] = ShSnValue;
    payload1['Type'] = ShSnType;
    this.umsService.getParameter(payload1).subscribe(res => {
      if (res.status) {
        if(item.EmName == "Common"){
          let degignation;
          let nameAuth;
          if(res.data[0].PrmTextType === "Autho"){
            degignation = res.data[0].PrmText
          }
          else if(res.data[1].PrmTextType === "Autho"){
            degignation = res.data[1].PrmText
          }
         if(res.data[0].PrmTextType === "Name"){
            nameAuth = res.data[0].PrmText
          }
          else if( res.data[1].PrmTextType === "Name"){
            // this.ParameterForm.controls['TextType'].setValue(res.data[1].PrmText);
            nameAuth = res.data[1].PrmText
          }
          this.ParameterForm = this.fb.group({
            Exam: new FormControl(item.ShId),
            Type: new FormControl(''),
            ShSn: new FormControl(''),
            Text1: new FormControl(degignation),
            TextType: new FormControl(nameAuth),
            Text: new FormControl(res.data[0].PrmText),
            BrId: new FormControl(res.data[0].PrmBrId),
            ResD: new FormControl(res.data[0].PrmResD)
          });
        }else{
          this.ParameterForm = this.fb.group({
            Exam: new FormControl(item.ShId),
            Type: new FormControl(''),
            ShSn: new FormControl(''),
            Text1: new FormControl(res.data[0].PrmText),
            TextType: new FormControl(res.data[0].PrmTextType),
            Text: new FormControl(res.data[0].PrmText),
            BrId: new FormControl(res.data[0].PrmBrId),
            ResD: new FormControl(res.data[0].PrmResD)
          });
        }
        if (item.EmName == "Common") {
          this.showVisibleAuto = true;
          this.ShowVisibleCale = false;
        } else {
          this.showVisibleAuto = false;
          this.ShowVisibleCale = true;
        }
      }
      else {
        this.ParameterForm = this.fb.group({
          Exam: new FormControl(item.ShId),
          Type: new FormControl(''),
          ShSn: new FormControl(''),
          TextType: new FormControl(''),
          Text: new FormControl(''),
          Text1: new FormControl(''),
          BrId: new FormControl(''),
          ResD: new FormControl('')
        });
        if (item.EmName == "Common") {
          this.showVisibleAuto = true;
          this.ShowVisibleCale = false;
        } else {
          this.showVisibleAuto = false;
          this.ShowVisibleCale = true;
        }
      }

    })

    let payload = {};
    payload['EmId'] = item.ShEmId;
    this.umsService.getExam(payload).subscribe((res) => {
      if (res.data[0].EmStreams == 'Y') {
        this.ExamBranch = true;
      } else {
        this.ExamBranch = false;
      }
      this.fetchBranch(item)
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide();
    });


  }

  fetchBranch(item) {
    const payload = {};
    payload['EmId'] = item.ShEmId;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }


  // this for Common Option need to add in dropdown
  addStaticOption() {
    const staticOption = {
      ShId: 'C',
      EmCode: 'C',
      EmName: 'Common'
    };
    if (!this.ExamAList.some(item => item.ShId === staticOption.ShId)) {
      this.ExamAList.push(staticOption);
    }
  }


}
